// extracted by mini-css-extract-plugin
export default {"eventButtons":"EventMenu_eventButtons__vAJC7","eventTitle":"EventMenu_eventTitle__o3beE"};